import {
  BiDisplayFormat,
  BiFormatSpec,
  biColumnFormatWith,
} from '@euler/model/bi/format';
import { BiQueryResult, BiResultColumn } from '@euler/model/bi/result';

export interface BiColumnRef {
  column: BiResultColumn;
  /** The column's position in each row. */
  index: number;
  /** How a measure reads (the viz's override first); none on a dimension. */
  format?: BiDisplayFormat;
}

/**
 * Looks a viz's column keys up in a result. A key the result lacks yields
 * null, so a viz that no longer matches its result renders as an error
 * rather than as a chart of zeros.
 */
export function biColumnLookup(
  result: BiQueryResult,
  formats: Record<string, BiFormatSpec> | undefined,
): (key: string) => BiColumnRef | null {
  return key => {
    const index = result.columns.findIndex(column => column.key === key);
    if (index < 0) return null;
    const column = result.columns[index];
    const override =
      formats && Object.prototype.hasOwnProperty.call(formats, key)
        ? formats[key]
        : undefined;
    return { column, index, format: biColumnFormatWith(column, override) };
  };
}
